module.exports = __webpack_public_path__ + "img/naotu_6.ea6864b7.png";